import { render, staticRenderFns } from "./LabelledInput.vue?vue&type=template&id=79c51cf8&scoped=true&"
import script from "./LabelledInput.vue?vue&type=script&lang=js&"
export * from "./LabelledInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c51cf8",
  null
  
)

export default component.exports